<div class="d-flex flex-row">

    @let routerParams = (params$ | async);

    <div class="container-fluid">
        <div class="row">
            <div class="col-9 p-0">
                <telxl-panel
                    [theme]="'success'"
                    cardClass="h-100 overflow-auto selected--green border-width--2px"
                    bodyClass="voice-green"
                >
                    <ng-template #cardBody>
                        <voice-monitor-call 
                            [callEndTime]="callEnded()"
                            [taskActive]="taskActive()"
                            [callId]="this.workItemStorev2.activeWorkItem()?.voiceCallId ?? 0"
                            [conversationId]="routerParams?.conversationId || ''"/>
                    </ng-template>
                </telxl-panel>
            </div>
            <div class="col-3 pe-1">
                <customer-interactions [workitem]="workItem()" />
            </div>
        </div>
    </div>
    
</div>
